import { Swiper } from 'swiper';
import { A11y, Navigation, Pagination } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', function () {
	const sliders = document.querySelectorAll('.block-card-taxonomy .swiper');
	const sliderViewCount = 2;
	const centeredSlides = false;
	const centeredSlidesMobile = false;

	if (sliders.length > 0) {
		sliders.forEach((slider) => {
			const progressBar = slider
				.closest('.block-card-taxonomy')
				.querySelector('.block-card-taxonomy__progress');

			const settings = {
				loop: false,
				grabCursor: true,
				slidesPerView: sliderViewCount,
				spaceBetween: 14,
				centeredSlides,
				modules: [A11y, Navigation, Pagination],
				a11y: {
					itemRoleDescriptionMessage: 'slide',
					slideLabelMessage: '',
				},
				navigation: {
					prevEl: slider
						.closest('.block-card-taxonomy')
						.querySelector('.swiper-button-prev'),
					nextEl: slider
						.closest('.block-card-taxonomy')
						.querySelector('.swiper-button-next'),
				},
				breakpoints: {
					0: {
						spaceBetween: 10,
						slidesPerView: 1,
						centeredSlides: centeredSlidesMobile,
					},

					576: {
						slidesPerView: 1,
						spaceBetween: 10,
					},
					768: {
						slidesPerView: 1,
						spaceBetween: 10,
					},
					769: {
						spaceBetween: 0,
						slidesPerView: 0,
					},
				},
				on: {
					init() {
						updateProgress(this, progressBar);
					},
					slideChange() {
						updateProgress(this, progressBar);
					},
				},
			};

			new Swiper(slider, settings);
		});
	}

	function updateProgress(swiper, progressBar) {
		if (!progressBar) return;

		const totalSlides =
			swiper.slides.length - swiper.params.slidesPerView + 1;
		const activeSlideIndex = swiper.activeIndex + 1;
		const progressPercentage = (activeSlideIndex / totalSlides) * 100;

		progressBar.style.width = `${progressPercentage}%`;
	}
});
